var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.GetAll,"label":_vm.$t('period'),"outlined":"","error-messages":_vm.errorMessages,"rules":[_vm.Rules.required],"dense":""},on:{"change":_vm.ChangeDropDown},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }